import type { FC } from 'react';

import '@data/Simulations/pipeline/blocks/AloneBlock';

type AloneParametersProps = {
    blockId: string;
};

const AloneParameters: FC<AloneParametersProps> = () => null;

export default AloneParameters;
